import React, { useCallback } from 'react';
import { Loader } from '@ui';
import { Checkbox } from '@ui/molecules/inputs/Checkbox';
import { translate } from '@utils/i18n';
import { TENANT_REGION_ULC } from '@constants/configs';
import useAIInspectionManager from '../../hooks/useAIInspectionManager';
import useUpdateAIInspectionManager from '../../hooks/useUpdateAIInspectionManager';
import './NeedsCorrectionTabStyles.scss';
const namespace = 'features.settings.ai_inspection_manager.needs_correction';
function NeedsCorrectionTab() {
    var _a, _b;
    const { data: settings, isLoading } = useAIInspectionManager();
    const { updateSettings } = useUpdateAIInspectionManager();
    const apiSettings = settings === null || settings === void 0 ? void 0 : settings.aiInspectionManagerNeedsCorrectionAdvancedSettings;
    const advancedSettings = {
        includeInHighImpactIssues: (_a = apiSettings === null || apiSettings === void 0 ? void 0 : apiSettings.includeInHighImpactIssues) !== null && _a !== void 0 ? _a : false,
        incorrectReferenceClause: (_b = apiSettings === null || apiSettings === void 0 ? void 0 : apiSettings.incorrectReferenceClause) !== null && _b !== void 0 ? _b : true
    };
    const tenantRegion = (settings === null || settings === void 0 ? void 0 : settings.tenantRegion) || '';
    const isULCTenant = tenantRegion === TENANT_REGION_ULC;
    const handleUpdateSettings = useCallback((updatedSettings) => {
        if (!settings)
            return;
        updateSettings.mutate({
            settingsUpdate: Object.assign(Object.assign({}, settings), { aiInspectionManagerNeedsCorrectionAdvancedSettings: updatedSettings })
        });
    }, [settings, updateSettings]);
    const handleCheckboxChange = useCallback((field, value) => {
        handleUpdateSettings(Object.assign(Object.assign({}, advancedSettings), { [field]: value }));
    }, [advancedSettings, handleUpdateSettings]);
    if (isLoading) {
        return (React.createElement("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' } },
            React.createElement(Loader, { size: "48", title: "Loading", vertical: true })));
    }
    return (React.createElement("div", { className: "needs-correction-tab main-section-container" },
        React.createElement("div", { className: "advanced-settings-section" },
            React.createElement("h3", { className: "advanced-settings-section__title" },
                translate('section_title', { namespace }),
                React.createElement("div", { className: "advanced-settings-section__title-line" })),
            React.createElement("div", { className: "advanced-settings-section__checkbox" },
                React.createElement(Checkbox, { id: "include-high-impact-needs-correction", label: translate('include_in_high_impact', { namespace }), checked: advancedSettings.includeInHighImpactIssues, onChange: (checked) => handleCheckboxChange('includeInHighImpactIssues', checked) }))),
        isULCTenant && (React.createElement("div", { className: "advanced-settings-section__checkbox" },
            React.createElement(Checkbox, { id: "incorrect-reference-clause", label: translate('incorrect_reference_clause', { namespace }), description: translate('incorrect_reference_clause_description', { namespace }), checked: advancedSettings.incorrectReferenceClause, onChange: (checked) => handleCheckboxChange('incorrectReferenceClause', checked) })))));
}
export default NeedsCorrectionTab;
